module.exports = __webpack_public_path__ + "static/media/visibilitat-05.f60eb320.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/visibilitat/visibilitat-05.svg
// module id = 785
// module chunks = 0